var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 61,
    viewBox: "0 0 69 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2849 16.7414H0V0H68.2849V16.7414ZM1.57266 15.168H66.7122V1.57344H1.57266V15.168Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.963 38.7697H0.0314941V22.0283H32.963V38.7697ZM1.57272 37.1963H31.3589V23.6018H1.57272V37.1963Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0919 60.7981H0V44.0566H48.0919V60.7981ZM1.57266 59.2246H46.5193V45.6301H1.57266V59.2246Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1427 0.503418H49.5701V15.8917H51.1427V0.503418Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4381 22.8779H17.8655V38.2662H19.4381V22.8779Z",
    fill: "#209BB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7624 44.5601H34.1897V59.9483H35.7624V44.5601Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21);
export default __webpack_public_path__ + "static/media/Group21.e43e3b6c95e19cbb6bd7aca4fd78257f.svg";
export { ForwardRef as ReactComponent };